// Records the version an automatic reload was aiming for, so coming back on the same build can
// be told apart from a first attempt. sessionStorage survives the reload and is scoped to the tab.
const RELOAD_TARGET_KEY = 'autoUpdateReloadTarget';

const storage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const clearReloadTarget = () => {
  try {
    storage()?.removeItem(RELOAD_TARGET_KEY);
  } catch {
    // Nothing to clean up if storage is unavailable.
  }
};

/**
 * Claims the right to auto-reload toward `version`. Returns false when we already reloaded for
 * this exact version and are still not running it — the deploy is mid-flight or the shell is
 * cached upstream, and reloading again would loop every couple of seconds.
 */
export const claimAutoReload = (version) => {
  if (!version) return true;

  let previous = null;
  try {
    previous = storage()?.getItem(RELOAD_TARGET_KEY) ?? null;
  } catch {
    previous = null;
  }

  if (previous === version) return false;

  try {
    storage()?.setItem(RELOAD_TARGET_KEY, version);
  } catch {
    // A blocked sessionStorage only costs us the loop guard, so still allow this reload.
  }

  return true;
};
